module.exports = __webpack_public_path__ + "media/highclass/service-features-tbsp-31c6c847.svg";